import { IConfig, UnleashClient } from "@unleash/proxy-client-react";

import {
  VITE_UNLEASH_URL,
  VITE_UNLEASH_CLIENT_KEY,
  VITE_UNLEASH_POLL_INTERVAL_SEC,
} from "../../ENV.ts";

export const UNLEASH_INITIAL_TIMEOUT_MS = 15_000;

// Bound both the request and its body so SDK.start() can reach its polling setup.
const fetchUnleash: typeof fetch = async (input, init) => {
  const controller = new AbortController();
  const abort = () => {
    controller.abort();
  };

  init?.signal?.addEventListener("abort", abort, { once: true });
  if (init?.signal?.aborted) {
    abort();
  }

  let timer: ReturnType<typeof setTimeout>;
  const timeout = new Promise<never>((_resolve, reject) => {
    timer = setTimeout(() => {
      reject(new Error("Unleash request timed out"));
      controller.abort();
    }, UNLEASH_INITIAL_TIMEOUT_MS);
  });

  const cleanup = () => {
    clearTimeout(timer);
    init?.signal?.removeEventListener("abort", abort);
  };

  try {
    const response = await Promise.race([fetch(input, { ...init, signal: controller.signal }), timeout]);
    if (response.ok) {
      const json: () => Promise<unknown> = response.json.bind(response);
      response.json = async () => {
        try {
          return await Promise.race([json(), timeout]);
        } finally {
          cleanup();
        }
      };
    } else {
      cleanup();
    }
    return response;
  } catch (error) {
    cleanup();
    throw error;
  }
};

const config: IConfig = {
  appName: "web-lk-frontend",
  url: VITE_UNLEASH_URL || "",
  clientKey: VITE_UNLEASH_CLIENT_KEY || "",
  refreshInterval: parseInt(VITE_UNLEASH_POLL_INTERVAL_SEC || ""),
  disableMetrics: true,
  fetch: fetchUnleash,
};

export const unleashClient = new UnleashClient(config);
